// extracted by mini-css-extract-plugin
export var copy = "application-item-module--copy--d91eb";
export var image = "application-item-module--image--8efb2";
export var root = "application-item-module--root--eaa96";
export var text = "application-item-module--text--ce00b";
export var title = "application-item-module--title--033e4";